<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 full-height-page-wrapper">
        <div class="page-table-header">
          <PageHeader showBreadcrumbs page-title="Items Management">
            <template #buttons>
              <b-button v-if="$can(permissions.CreateFinancesProjectSpecialisations)" variant="success" class="button"
                @click="showCreateInvoicesModal">
                Create
              </b-button>
            </template>
          </PageHeader>
        </div>

        <div v-if="isDataPageLoading" class="content-loading-wrapper" style="min-height: 60vh;">
          <Preloader class="centered-preloader large-spinner" />
        </div>

        <TableForPage v-else-if="getSpecialisations.length" :tableData="getSpecialisations" :fields="invoiceFields"
          :isRemove="$can(permissions.DeleteFinancesProjectSpecialisations)"
          :isEdit="$can(permissions.UpdateAllFinancesProjectSpecialisations)" @edit="showEditInvoicesModal"
          @remove="removeProjectSpecialisation" />

        <div v-else class="full-height-content">
          <EmptyStateNoResults
            customIcon="code"
            customIconClasses="material-symbols-outlined empty-state__icon"
            title="No specialisation items yet"
            description="Add specialisation items to categorize expertise, roles, or services for better organization and filtering."
            buttonText="CREATE"
            @button-click="handleCreateClick"
          />
        </div>
      </div>
    </div>
    <b-modal size="md" hide-footer v-model="createSpecialisationModal.show" class="modal" centered :modal-class="isCreateModalLoading ? 'loading' : ''">
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{createSpecialisationModal.title}}</h5>
        <button type="button" aria-label="Close" class="close" @click.prevent="cancel">
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FinancesProjectSpecialisationForm @submit="createProjectSpecialisation" :isLoading="isCreateModalLoading" />
    </b-modal>
    <b-modal size="md" hide-footer v-model="editSpecialisationModal.show" :title="editSpecialisationModal.title"
      class="modal" centered :modal-class="isEditModalLoading ? 'loading' : ''">
      <FinancesProjectSpecialisationForm :formData="editSpecialisationModal.formData"
        :submitButtonText="editSpecialisationModal.submitButtonText" @submit="editProjectSpecialisation" :isLoading="isEditModalLoading" />
    </b-modal>
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import FinancesProjectSpecialisationForm from '@forms/FinancesProjectSpecialisationForm'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'
import EmptyStateNoResults from '@components/EmptyStateNoResults'

export default {
  name: 'FinancesProjectSpecialisation',
  components: {
    FinancesProjectSpecialisationForm,
    TableForPage,
    PageHeader,
    Preloader,
    EmptyStateNoResults
  },
  data () {
    return {
      permissions: permissions,
      isCreateModalLoading: false,
      isEditModalLoading: false,
      createSpecialisationModal: {
        show: false,
        title: 'Create project specialisation'
      },
      editSpecialisationModal: {
        show: false,
        title: 'Edit project specialisation',
        submitButtonText: 'Edit',
        formData: null
      },
      invoiceFields: [
        {
          key: 'id',
          label: 'Id'
        },
        {
          key: 'type_display_name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'type_name',
          label: 'Type',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'action_column'
        }
      ]
    }
  },
  created () {
    this.fetchInvoiceProjectSpecialisations()
  },
  computed: {
    ...mapGetters({
      getSpecialisations: 'finances/getSpecialisations'
    }),
    getTotalSpecialisation () {
      return this.getSpecialisations.length
    }
  },
  methods: {
    showCreateInvoicesModal () {
      this.createSpecialisationModal.show = true
    },
    hideCreateInvoicesModal () {
      this.createSpecialisationModal.show = false
    },
    showEditInvoicesModal (params) {
      this.editSpecialisationModal.show = true
      this.setParamsForEditInvoicesModal(params)
    },
    hideEditInvoicesModal () {
      this.editSpecialisationModal.show = false
    },
    setParamsForEditInvoicesModal (params) {
      this.editSpecialisationModal.formData = params
    },

    fetchInvoiceProjectSpecialisations () {
      if (this.getTotalSpecialisation) return

      this._toggleDataPageLoading(() => this.$api.finances.getInvoiceProjectSpecialisations())
    },
    createProjectSpecialisation (data) {
      this.isCreateModalLoading = true
      this.$api.finances.createInvoiceProjectSpecialisations(data)
        .then(() => {
          this.hideCreateInvoicesModal()
          this.fetchInvoiceProjectSpecialisations()
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.isCreateModalLoading = false
        })
    },
    editProjectSpecialisation (data) {
      this.isEditModalLoading = true
      this.$api.finances.editInvoiceProjectSpecialisations(data)
        .then(() => {
          this.hideEditInvoicesModal()
          this.fetchInvoiceProjectSpecialisations()
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.isEditModalLoading = false
        })
    },
    async removeProjectSpecialisation (data) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the project specialisation ?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(() => this.$api.finances.removeInvoiceProjectSpecialisations(data.id))
    },
    handleCreateClick () {
      this.showCreateInvoicesModal()
    }
  }
}
</script>
